import { useParams } from 'react-router-dom'
import {useState, useEffect} from 'react'
import useForm from './useForm';

function useBank() {
    const [bankData, setBankData] = useState({})
    const { token } = useParams();
    const { seterrmsg } = useForm();

    useEffect(() => {
        const getBankDetails = async(token) => {
          const  getOptions = {
                method : 'GET',
              headers: {
                "Content-Type" : "application/json",
                "Accept": "application/json",
                'Authorization': `Bearer ${token}`
               }
            };
            await fetch(`${process.env.REACT_APP_API_URL}/bank/get`, getOptions)
            .then (response => response.json())
            .then (data => {
                if (data.bank_details){
                   setBankData(data.bank_details)
                } else {
                    seterrmsg("Couldn't get bank details" )
                }
            })
             .catch(err => console.log(err))  
        }

        getBankDetails(token);
    },[token, seterrmsg])

  return {bankData}
}

export default useBank